<script setup lang="ts">

//
// Props
interface Props {
  title: string
  notice: string
  cancel: string
  confirm: string
  callback: () => void
}

const props = defineProps<Props>()

//
// Emit
interface Events {
  (e: "close"): void
}
const emit = defineEmits<Events>()

//
// Methods
const onConfirm = (): void => {
  emit("close")
  props.callback()
}
</script>

<template>
  <focus-trap>
    <div
      tabindex="-1"
      class="modal d-block _confirmation_modal"
      @click.self="emit('close')"
      @keyup.esc="emit('close')"
    >
      <div class="modal-dialog modal-dialog-centered modal-557px">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bold">
              {{ title }}
            </h5>
          </div>
          <div class="modal-body">
            <p>{{ notice }}</p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default _cancel"
              @click="emit('close')"
            >
              {{ cancel }}
            </button>

            <button
              type="button"
              class="btn btn-danger _confirm"
              @click="onConfirm"
            >
              {{ confirm }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </focus-trap>
</template>
